module.exports = __webpack_public_path__ + "static/media/n_icon_highlight@2x.a9deb010.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_highlight@2x.png
// module id = 1806
// module chunks = 0 1